import React from 'react'
import { SvgProps } from './SvgProps'
import { svgTransform } from './svgTramsform'

export const CongestionCircleSvg = ({ size }: SvgProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        transform: svgTransform(size),
      }}
    >
      <path
        d="M0 3C0 1.89543 0.895431 1 2 1H22C23.1046 1 24 1.89543 24 3V21C24 22.1046 23.1046 23 22 23H2C0.89543 23 0 22.1046 0 21V3Z"
        fill="#FF9418"
      />
      <path
        d="M10.5 9C10.5 10.6569 9.15685 12 7.5 12C5.84315 12 4.5 10.6569 4.5 9C4.5 7.34315 5.84315 6 7.5 6C9.15685 6 10.5 7.34315 10.5 9Z"
        fill="white"
      />
      <path
        d="M19.5 9C19.5 10.6569 18.1569 12 16.5 12C14.8431 12 13.5 10.6569 13.5 9C13.5 7.34315 14.8431 6 16.5 6C18.1569 6 19.5 7.34315 19.5 9Z"
        fill="white"
      />
      <path
        d="M4.5 14C4.5 12.8954 5.39543 12 6.5 12H8.5C9.60457 12 10.5 12.8954 10.5 14V19H4.5V14Z"
        fill="white"
      />
      <path
        d="M13.5 14C13.5 12.8954 14.3954 12 15.5 12H17.5C18.6046 12 19.5 12.8954 19.5 14V19H13.5V14Z"
        fill="white"
      />
    </svg>
  )
}
